// lib files
import NewsletterList from "@/lib/types/newsletters"

// components
import ITSPicture from '@/components/ITSPicture/ITSPicture';

// styles
import styles from '@/components/Newsletter/Newsletter.module.scss'

interface NewsletterImageProps {
  list?: NewsletterList
}

export default function NewsletterImage(props: NewsletterImageProps) {
  const { list } = props;

  switch (list) {
    case NewsletterList.drama:
      var backgroundImage = 'https://image.pbs.org/webobjects/Woods_2-LjeBFrw.png'
      var focalCrop = '40x20'
      break;
    case NewsletterList.mystery:
      var backgroundImage = 'https://image.pbs.org/webobjects/Patience_S2_Amy_Brammall_362A5089-g4vXvdr.jpg'
      var focalCrop = '50x20'
      break;
    case NewsletterList.science:
      var backgroundImage = 'https://image.pbs.org/webobjects/OCP2_ARC_CP_MuskoxenHerd_3-xqw0Ni4.png'
      var focalCrop = '50x35'
      break;
    default:
      var backgroundImage = 'https://image.pbs.org/webobjects/newsletter-signup-background_14402x-GeavgpU.jpg'
      var focalCrop = '80x20'
      break;
  }

  return (
    <ITSPicture
      src={backgroundImage}
      alt={''}
      width={1700}
      height={240}
      resizeWithCrop={true}
      loading="lazy"
      fetchPriority="low"
      format="avif"
      sources={[
        {
          minWidth: 1700,
          width: 1700,
          height: 240,
          focalcrop: focalCrop,
        },
        {
          minWidth: 1440,
          width: 1440,
          height: 240,
          focalcrop: focalCrop,
        },
        {
          minWidth: 1280,
          width: 1280,
          height: 240,
          focalcrop: focalCrop,
        },
        {
          minWidth: 1024,
          width: 1024,
          height: 210,
          focalcrop: focalCrop,
        },
        {
          minWidth: 768,
          width: 768,
          height: 200,
          focalcrop: focalCrop,
        },
        {
          minWidth: 500,
          width: 500,
          height: 200,
          focalcrop: focalCrop,
        },
        {
          minWidth: 320,
          width: 375,
          height: 200,
          focalcrop: focalCrop,
        },
      ]}
      ariaHidden={true}
      className={styles.background}
    />
  )
}
